import Cookies from "js-cookie";
import {IAuthenticatedEmployee} from "shared/entities/employee";
import {Api} from "shared/api";

const TOKEN_ID = "jwt";

export class AuthService {
    private static cachedEmployee: IAuthenticatedEmployee|null = null;

    public static initialize() {
        try {
            const token = AuthService.getToken();
            AuthService.setToken(token);
            return true;
        } catch (e) {
            return false;
        }
    }

    public static async validate() {
        try {
            AuthService.cachedEmployee = null;
            await AuthService.getSelf();
            return true;
        } catch (e) {
            // eslint-disable-next-line no-console
            console.debug(e);
            return false;
        }
    }

    public static setToken(token: string) {
        Cookies.set(TOKEN_ID, token);
        if (Api._options.params.headers) Api._options.params.headers.token = token;
    }

    public static getToken(): string {
        const token = Cookies.get(TOKEN_ID);
        if (!token) {
            throw new Error("Token not found");
        }
        return token;
    }

    public static clearToken(): void {
        this.cachedEmployee = null;
        Cookies.remove(TOKEN_ID);
        if (Api._options.params.headers && Api._options.params.headers.token) delete Api._options.params.headers.token;
    }

    public static clearCache() {
        this.cachedEmployee = null;
    }

    public static async getSelf(): Promise<IAuthenticatedEmployee> {
        if (this.cachedEmployee) return this.cachedEmployee;
        const response = await Api.auth.Self.Get();
        if (!response.success) {
            throw new Error("Not Authorized");
        }
        this.cachedEmployee = response.result;
        return response.result;
    }
}
